var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelebratory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFCF00;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,65.15l-10.65,5.6c-2.52,1.32-5.46-0.81-4.98-3.62l2.03-11.86l-8.62-8.4c-2.04-1.99-0.91-5.45,1.9-5.86 l11.91-1.73l5.33-10.79c1.26-2.55,4.9-2.55,6.16,0l5.33,10.79l11.91,1.73c2.82,0.41,3.94,3.87,1.9,5.86l-8.62,8.4l2.03,11.86 c0.48,2.81-2.46,4.94-4.98,3.62L75,65.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,65.15l-10.65,5.6c-2.52,1.32-5.46-0.81-4.98-3.62l2.03-11.86l-8.62-8.4c-2.04-1.99-0.91-5.45,1.9-5.86 l11.91-1.73l5.33-10.79c1.26-2.55,4.9-2.55,6.16,0l5.33,10.79l11.91,1.73c2.82,0.41,3.94,3.87,1.9,5.86l-8.62,8.4l2.03,11.86 c0.48,2.81-2.46,4.94-4.98,3.62L75,65.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 21.81,
    y1: 41.57,
    x2: 8.36,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 19.78,
    y1: 44.7,
    x2: 6.61,
    y2: 42.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 23.69,
    y1: 50.39,
    x2: 21.25,
    y2: 63.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 29.38,
    y1: 46.47,
    x2: 42.55,
    y2: 48.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 25.47,
    y1: 40.79,
    x2: 27.9,
    y2: 27.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 20.56,
    y1: 48.35,
    x2: 0.99,
    y2: 61.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 27.34,
    y1: 49.61,
    x2: 40.8,
    y2: 69.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 28.6,
    y1: 42.82,
    x2: 48.17,
    y2: 29.37
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 128.19,
    y1: 41.57,
    x2: 141.64,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 130.22,
    y1: 44.7,
    x2: 143.39,
    y2: 42.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 126.31,
    y1: 50.39,
    x2: 128.75,
    y2: 63.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 120.62,
    y1: 46.47,
    x2: 107.45,
    y2: 48.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 124.53,
    y1: 40.79,
    x2: 122.1,
    y2: 27.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 129.44,
    y1: 48.35,
    x2: 149.01,
    y2: 61.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 122.66,
    y1: 49.61,
    x2: 109.2,
    y2: 69.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 121.4,
    y1: 42.82,
    x2: 101.83,
    y2: 29.37
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.29,98.84l4.61,5.08c1.09,1.2,3.08,0.63,3.37-0.96l1.23-6.75l6.25-2.81c1.48-0.67,1.55-2.74,0.13-3.51 l-6.04-3.25l-0.74-6.82c-0.18-1.61-2.12-2.32-3.3-1.2l-4.96,4.73l-6.71-1.4c-1.59-0.33-2.87,1.3-2.16,2.76l2.97,6.18l-3.41,5.95 c-0.81,1.41,0.35,3.13,1.96,2.91L102.29,98.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.29,98.84l4.61,5.08c1.09,1.2,3.08,0.63,3.37-0.96l1.23-6.75l6.25-2.81c1.48-0.67,1.55-2.74,0.13-3.51 l-6.04-3.25l-0.74-6.82c-0.18-1.61-2.12-2.32-3.3-1.2l-4.96,4.73l-6.71-1.4c-1.59-0.33-2.87,1.3-2.16,2.76l2.97,6.18l-3.41,5.95 c-0.81,1.41,0.35,3.13,1.96,2.91L102.29,98.84z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 99.89,
    y1: 105.42,
    x2: 92.51,
    y2: 125.65
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.71,98.84l-4.61,5.08c-1.09,1.2-3.08,0.63-3.37-0.96l-1.23-6.75l-6.25-2.81 c-1.48-0.67-1.55-2.74-0.13-3.51l6.04-3.25l0.74-6.82c0.18-1.61,2.12-2.32,3.3-1.2l4.96,4.73l6.71-1.4 c1.59-0.33,2.87,1.3,2.16,2.76l-2.97,6.18l3.41,5.95c0.81,1.41-0.35,3.13-1.96,2.91L47.71,98.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.71,98.84l-4.61,5.08c-1.09,1.2-3.08,0.63-3.37-0.96l-1.23-6.75l-6.25-2.81 c-1.48-0.67-1.55-2.74-0.13-3.51l6.04-3.25l0.74-6.82c0.18-1.61,2.12-2.32,3.3-1.2l4.96,4.73l6.71-1.4 c1.59-0.33,2.87,1.3,2.16,2.76l-2.97,6.18l3.41,5.95c0.81,1.41-0.35,3.13-1.96,2.91L47.71,98.84z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 50.11,
    y1: 105.42,
    x2: 57.49,
    y2: 125.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 75,
    y1: 72.87,
    x2: 75,
    y2: 121.32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 22.34,
    y1: 114.28,
    x2: 12.4,
    y2: 109.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 23.61,
    y1: 118.05,
    x2: 18.65,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 27.38,
    y1: 116.79,
    x2: 37.33,
    y2: 121.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 26.12,
    y1: 113.01,
    x2: 31.08,
    y2: 103.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 127.66,
    y1: 114.28,
    x2: 137.6,
    y2: 109.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 126.39,
    y1: 118.05,
    x2: 131.35,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 122.62,
    y1: 116.79,
    x2: 112.67,
    y2: 121.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 123.88,
    y1: 113.01,
    x2: 118.92,
    y2: 103.07
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebratory);
export default __webpack_public_path__ + "static/media/Celebratory.0bf28ae09db7f2185cb0fb8ead59538b.svg";
export { ForwardRef as ReactComponent };